import React, { useState } from "react";
import "./menuItems.css";
import moment from "moment";
import PutAPI from "../../APICalls/PutAPI";

const MenuItems = ({
  item,
  selected,
  selectedMenuType,
  setLoading,
  menuAPI,
  refreshMenuData,
  handleEdit,
  isXpress,
}) => {
  const today = moment();
  const tomorrow = moment().add(1, "day");

  const isItemAvailable = item.itemForever
    ? true
    : selected.toUpperCase() === "DAILYMENU"
    ? item.availableDates[selectedMenuType]?.includes(
        today.format("YYYY-MM-DD")
      )
    : item.availableDates[selectedMenuType]?.includes(
        tomorrow.format("YYYY-MM-DD")
      );

  const [isEnabled, setIsEnabled] = useState(
    isXpress ? item.itemAvailable : isItemAvailable
  );

  const handleToggle = () => {
    let dataToPut;
    if (isXpress) {
      dataToPut = {
        menuID: item.menuID,
        itemAvailable: !item.itemAvailable,
        type: "SOLD_OUT",
        menuType: item.menuType,
        isXpress:true
      };
    } else {
      if (item.itemForever) {
        alert("itemForever item cannot be turned off");
        return;
      }
      dataToPut = {
        menuID: item.menuID,
        type: "TOGGLING",
        selectedMenuType: selectedMenuType,
        availableDates: item.availableDates,
        isAvailability: !isEnabled,
        isPreOrder: item.isPreOrder,
      };
    }

    setLoading(true);
    PutAPI(menuAPI, dataToPut)
      .then((res) => {
        if (res.data.statusCode === 200) {
          setIsEnabled(!isEnabled);
          refreshMenuData();
          alert(`Successfully turned ${!isEnabled ? "on" : "off"} menu`);
        } else {
          console.error(res);
          setLoading(false);
            alert(`Failed to turn ${!isEnabled ? "on" : "off"} menu`);
        }
      })
      .catch((e) => {
        console.error(e);
        setLoading(false);
          alert(`Failed to turn ${!isEnabled ? "on" : "off"} menu`);
      });
  };

  return (
    <div key={item.itemID} className="menu-card">
      <div className="menu-card-image">
        <img
          src={
            item.imageUrl !== "N/A"
              ? item.imageUrl
              : "https://d2nahbmqd5vvug.cloudfront.net/appdata/icon_foodLove.png"
          }
          alt={item.itemName}
        />
        <div className="menu-card-overlay">
          <p className="menu-card-title">{item.itemName}</p>
        </div>
      </div>
      <div className="menu-card-body">
        <div className="menu-card-top">
        {!isXpress ? <div>
            <div className="menu-card-price">Chef Price</div>
            <div className="menu-card-price">₹{item.chefCost}</div>
          </div> : null}
          <div>
            <div className="menu-card-price">Item Price</div>
            <div className="menu-card-price">₹{item.itemPrice}</div>
          </div>
          <div className="menu-card-toggle">
            <div className="menu-card-price">
              {isEnabled ? "ON" : "OFF"}
            </div>
            <label className="switch">
              <input
                type="checkbox"
                checked={isEnabled}
                onChange={handleToggle}
              />
              <span className="slider round"></span>
            </label>
          </div>
        </div>
        <div className="menu-card-divider"></div>
        <div className="menu-card-bottom">
          <div className="menu-card-info">
            <img
              src={ReturnItemType(item)}
              alt={item.itemType}
              className="menu-card-icon"
            />
            <span className="menu-card-menu-type">
              {item?.menuType?.join(", ")}
            </span>
          </div>
          <button
            type="button"
            className="btn btn-warning btn-sm"
            onClick={() => handleEdit(item.menuID)}
          >
            Edit
          </button>
        </div>
      </div>
    </div>
  );
};

// Function to determine the item type icon URL
const ReturnItemType = (item) => {
  switch (item?.itemType?.toUpperCase()) {
    case "VEGETARIAN":
      return "https://d2nahbmqd5vvug.cloudfront.net/appdata/VegIcon.png";
    case "NONVEGETARIAN":
      return "https://d2nahbmqd5vvug.cloudfront.net/appdata/NonVegIcon.png";
    default:
      return "https://d2nahbmqd5vvug.cloudfront.net/appdata/EggIcon.png";
  }
};

export default MenuItems;
